export default __webpack_public_path__ + "static/media/001-slumber.21befaf7.svg";